import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';
import { ToothNotation } from './types';

interface ToothNumberingToggleProps {
  value: ToothNotation;
  onChange: (notation: ToothNotation) => void;
}

export function ToothNumberingToggle({ value, onChange }: ToothNumberingToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex rounded-lg border border-ds-field bg-ds-sunk p-1">
      <button
        type="button"
        onClick={() => onChange('fdi')}
        className={cn(
          'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
          value === 'fdi'
            ? 'bg-ds-card text-ds-text shadow-card'
            : 'text-ds-muted hover:text-ds-text',
        )}
      >
        {t('dental.numbering.fdi')}
      </button>
      <button
        type="button"
        onClick={() => onChange('haderup')}
        className={cn(
          'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
          value === 'haderup'
            ? 'bg-ds-card text-ds-text shadow-card'
            : 'text-ds-muted hover:text-ds-text',
        )}
      >
        {t('dental.numbering.haderup')}
      </button>
    </div>
  );
}
